import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faBalanceScale,
    faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import {
    faChrome,
    faFirefox,
    faEdge,
    faInternetExplorer,
    faSafari
} from '@fortawesome/free-brands-svg-icons';

library.add(
    faBalanceScale,
    faChevronRight,
    faChrome,
    faFirefox,
    faEdge,
    faInternetExplorer,
    faSafari
);

@NgModule({
  imports: [
    FontAwesomeModule
  ],
  declarations: []
})
export class FaLibraryModule { }
